import { z } from 'zod';
import { storeRepeatedChecklistReqDto } from './store-repeated-checklist.req.dto';

export const storeRepeatedChecklistResDto = storeRepeatedChecklistReqDto;
export type StoreRepeatedChecklistResDto = z.infer<
  typeof storeRepeatedChecklistResDto
>;
